let isMouseCurrentlyDown = false;

document.addEventListener('mousedown', () => {
  isMouseCurrentlyDown = true;
});

document.addEventListener('mouseup', () => {
  isMouseCurrentlyDown = false;
});

export default function isMouseDown() {
  return isMouseCurrentlyDown;
}
